var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('span',[_vm._v("not Found!")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n    Go Back Home\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }